import { render, staticRenderFns } from "./estimate-orders-edit.vue?vue&type=template&id=06eb2e48&scoped=true&"
import script from "./estimate-orders-edit.vue?vue&type=script&lang=js&"
export * from "./estimate-orders-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eb2e48",
  null
  
)

export default component.exports